var _path, _path2, _circle, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRolesAndPermissionsBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#0F538D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 15l-2 2l2 2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15l2 2l-2 2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 7,
    r: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 21a6.5 6.5 0 0 1 13 0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRolesAndPermissionsBlue);
export default __webpack_public_path__ + "static/media/RolesAndPermissionsBlue.ed23b38cb1eb2ad7c43cf9366e6faa0b.svg";
export { ForwardRef as ReactComponent };